export default {
  content: {
    maxWidth: '460px',
    font: 'var(--body)',
    '& p': {
      margin: '20px 0 0',
      '&:first-child': {
        marginTop: '0'
      }
    }
  },
  holder: {
    padding: '40px 20px'
  },
  actions: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *:first-child': {
      marginRight: '10px'
    }
  }
}
